export const displayElement = (id: string, option: string) => {
    console.log(document.getElementById(id) as HTMLInputElement)
    ;(document.getElementById(id) as HTMLInputElement).style.display = option
}
